import { Base } from './base';
export class MaxLength extends Base {
    constructor(fieldName, value, max, errorMsg) {
        super(fieldName, value);
        this.max = max;
        if (errorMsg)
            this.errorMsg = errorMsg;
        if (!errorMsg)
            this.errorMsg = `"${this.getFieldname()}" must be less than or equal to ${this.max}`;
    }
    isValid() {
        const value = String(this.value);
        if (value.length > this.max) {
            this.errors.push(this.errorMsg);
            return false;
        }
        return true;
    }
}
//# sourceMappingURL=maxLength.js.map